<template>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-left">
          {{ $t('components.Calculations.Variants.ViewParts.SurchargeCashSalePriceTab.Position') }}
        </th>
        <th class="text-left">
          {{ $t('components.Calculations.Variants.ViewParts.SurchargeCashSalePriceTab.Costs') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          {{ $t('entities.part.fields.production_costs_part') }}
        </td>
        <td>
          {{ new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(variant.production_costs_part) }}
        </td>
      </tr>

      <tr>
        <td>
          {{ $t('entities.part.fields.surcharges_part') }}
        </td>
        <td>
          {{ new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(variant.surcharges_part) }}
        </td>
      </tr>

      <tr>
        <td>
          {{ $t('entities.part.fields.cost_price_part') }}
        </td>
        <td>
          {{ new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(variant.cost_price_part) }}
        </td>
      </tr>

      <tr>
        <td>
          {{ $t('entities.part.fields.profit_part') }}
        </td>
        <td>
          {{ new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(variant.profit_part) }}
        </td>
      </tr>

      <tr>
        <td>
          {{ $t('entities.part.fields.cash_sales_price_part') }}
        </td>
        <td>
          {{ new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(variant.cash_sales_price_part) }}
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<script setup>
defineProps({
  variant: {
    type: Object,
    required: true
  }
});

</script>
